var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLensEnhanceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H21C18.672 0 16 2.728 16 24C16 45.272 18.672 48 21 48H27C29.328 48 32 45.272 32 24C32 2.728 29.328 0 27 0ZM18 24C18 2.25 20.877 2 21 2H24.388C23.04 4.676 22 10.729 22 24C22 37.271 23.04 43.324 24.388 46H21C20.877 46 18 45.75 18 24ZM27 46C26.877 46 24 45.75 24 24C24 2.25 26.877 2 27 2C27.123 2 30 2.25 30 24C30 45.75 27.123 46 27 46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensEnhanceWhite);
export default __webpack_public_path__ + "static/media/lensEnhance_white.54aef05cd91073cc0f53032e0713cff6.svg";
export { ForwardRef as ReactComponent };